import sanityClient from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'

export const client = sanityClient({
    projectId: 'lvg32mv0',
    dataset: 'production',
    apiVersion: '2022-03-17',
    useCdn: true,
    token: 'skNXMX84zWBVQTAHoW2NJWYBlfp926vStHOy4594zz58emgID2WgCehypzR4wnWCTj1h1sbuS2G9TMN8Cn9DyjnNHPEk9Ws29fj0FX390XRa77mqYywl5TIflOuRUyLCTOLRnhBVM6xqLYZH30NaPhYCneYdLdndZJ3eQRJddZb5pBLJCbji',
});

const builder = imageUrlBuilder(client)

export const urlFor = (source) => builder.image(source)